import React, { useEffect } from 'react';
import {Button, Form, Input, Modal } from 'antd';
import * as Icon from "react-feather";
import { useDispatch } from 'react-redux';
import appLoaderAction from '../../../redux/action/app-loader-action';
import notifyUtitls from '../../../utils/notify-utils';
import documentGalleryService from '../../../services/document-gallery-service';

const AddEditFolderDialog = ({ isShow, onCancel, onSaveComplete, editData, currentParent, currentPath }) => {
    const dispatch = useDispatch();
    const [form] = Form.useForm();

    useEffect(() => {
        if (isShow && editData) {
            form.setFieldsValue({
                folderName: editData.folderName,
                shortDescription: editData.shortDescription
            });
        } else {
            form.setFieldsValue({
                folderName: null,
                shortDescription: null
            });
        }
    }, [isShow, editData]);

    const onAddFolder = async () => {
        try {
            const values = await form.validateFields();
            try {
                let pathValue = "/"
                dispatch(appLoaderAction.enable());
                if (!editData) {
                    let parentValue = null;
                    if (currentParent === "root") {
                        parentValue = currentParent
                        pathValue = ""
                    } else {
                        parentValue = currentParent
                        currentPath.forEach((res) => {
                            pathValue = pathValue + res + "/";
                        });
                    }

                    let bean = {
                        folder : "true",
                        parent : parentValue,
                        path: pathValue,
                        folderName : values.folderName,
                        shortDescription : values.shortDescription
                    };
                    await documentGalleryService.createFolder({bean: bean});
                } else {
                    let bean = JSON.parse(JSON.stringify(editData));
                    // bean.folderName = values.folderName;
                    // bean.shortDescription = values.shortDescription;
                    // const editResult = {
                    //     bean: {
                    //         ...bean
                    //     }
                    // }

                    const formData = new FormData();

                    formData.append("folder", true);
                    formData.append("parent", bean.parent);
                    formData.append("path", bean.path);
                    formData.append("shortDescription", values.shortDescription);
                    formData.append("folderName", values.folderName);
                    formData.append("id", bean.id);
                    formData.append("newPath", bean.newPath);
                    formData.append("enable",true);


                    await documentGalleryService.edit(formData);
                }
                dispatch(appLoaderAction.disale());
                notifyUtitls.success('สำเร็จ', 'บันทึกสำเร็จ');
                onSaveComplete();
            } catch (err) {
                notifyUtitls.error(err);
                dispatch(appLoaderAction.disale());
            }
        } catch (errorInfo) {
            notifyUtitls.warning('แจ้งเตือน', 'โปรดระบุข้อมูลให้ครบถ้วน');
        }
    };

    return (
        <div className="container h-100">
            <div className="title-page">
                <Modal
                    title={
                        editData ? 'แก้ไขโฟล์เดอร์' : 'เพิ่มโฟล์เดอร์'
                    }
                    centered
                    width={750}
                    visible={isShow}
                    onCancel={onCancel}
                    destroyOnClose
                    footer={[
                        <Button key="submit" type="primary" onClick={onAddFolder}>
                            <Icon.Save className="me-2" size={17} />{editData ? 'บันทึก' : 'เพิ่มโฟล์เดอร์'}
                        </Button>,
                        <Button key="back" className="btn-gray" onClick={onCancel}>
                            <Icon.X className="me-2" size={17} />ยกเลิก
                        </Button>,
                    ]}>
                    <Form
                        layout="vertical"
                        name="add_edit_banner"
                        preserve={false}
                        form={form}
                        initialValues={{status: true, enableNewTab: true}}>

                        <Form.Item 
                            label="ชื่อโฟลเดอร์" 
                            name="folderName"
                            rules={[
                                {
                                    required: true,
                                },
                            ]
                        }>
                            <Input />
                        </Form.Item>
                        <Form.Item 
                            label="คำอธิบาย" 
                            name="shortDescription"
                            rules={[
                                {
                                    required: false,
                                },
                            ]
                        }>
                            <Input />
                        </Form.Item>
                    </Form>
                </Modal>
            </div>
        </div>
    )
}

export default AddEditFolderDialog;
